// src/api/login.ts

import request from '@/utils/axios'  // ← 引用你创建的 axios 实例（路径按你的项目来）

// 后端统一响应（按你的返回结构调整）
type ApiResp<T = any> = { code: number; message: string; data: T }

export interface RegisterPayload {
  username: string
  password: string
  confirmPassword: string
  email: string
  phone: string // 映射到后端的 tel
}

export async function register(payload: RegisterPayload) {
  const fd = new FormData()
  fd.append('username', payload.username)
  fd.append('password', payload.password)
  fd.append('confirm_password', payload.confirmPassword)
  fd.append('email', payload.email)
  fd.append('tel', payload.phone)

  const res = (await request.post('/common/register', fd, {
    headers: { 'Content-Type': undefined }, // 让浏览器自动带 multipart 边界
  })) as ApiResp

  if (res.code !== 1) {
    throw new Error(res.message || '注册失败')
  }
  return res.data
}


export interface LoginPayload {
  username: string
  password: string
}

export interface LoginData {
  accessToken: string
  refreshToken: string
  tokenType: string // "Bearer"
  expiresIn: number // seconds
  userInfo: {
    userId: number
    username: string
    realName: string | null
    role: number
    department: number
    email: string | null
    tel: string | null
  }
}

export async function login(payload: LoginPayload) {
  let v = (payload.username || '').trim()
  v = v.replace(/\s+/g, '')
  if (v.startsWith('+86')) v = v.slice(3)
  if (v.startsWith('86') && v.length === 13) v = v.slice(2)

  const isPhone = /^1[3-9]\d{9}$/.test(v)

  const doReq = async (useTel: boolean) => {
    const fd = new FormData()
    fd.append(useTel ? 'tel' : 'username', v)
    fd.append('password', payload.password)

    // 关键：后端返回的是 ApiResp<LoginData>
    const res = (await request.post('/common/login', fd, {
      headers: { 'Content-Type': undefined },
    })) as ApiResp<LoginData>

    return res
  }

  // 先按输入类型选择字段名
  let res = await doReq(isPhone)

  // 如果失败，用另一种字段名再试一次
  if (res.code !== 1) {
    res = await doReq(!isPhone)
  }

  if (res.code !== 1) {
    throw new Error(res.message || '登录失败')
  }

  // 返回 data（即 { accessToken, refreshToken, ... }）
  return res.data
}


// 退出登录
export async function logout() {
  // axios.ts response 拦截器已经 return response.data，所以这里拿到的是 ApiResp
  const res = (await request.get('/common/logout')) as ApiResp<{}>

  // 这里不要 throw（建议容错），因为退出时 token 可能已过期/被清
  return res
}


